class employees {
  constructor(id, name, instans, file) {
    this.id = id;
    this.name = name;
    this.instans = instans;
    this.file = file;
  }
  static fromJson({ empId, empNombre, instancias, legajo }) {
    return new employees(empId, empNombre, instancias, legajo);
  }
}
export default employees;
